import { Button } from '@aecom-ai-engineering/react-components';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from 'reactjs-popup';

import { PropChat } from './prop-chat';
import { type PropChatVariant } from './types';
import { usePropChat } from './use-prop-chat';

interface PropChatContentProps {
  variant: PropChatVariant;
}

export const PropChatContent: FC<PropChatContentProps> = ({ variant }) => {
  const { t } = useTranslation();
  const {
    disabled,
    isResumedChat,
    loadingAnswer,
    loadingStatus,
    messages,
    onMessage,
    propChatDisclaimerShown,
    setPropChatDisclaimerShown,
  } = usePropChat();

  return (
    <>
      <Popup
        open={!propChatDisclaimerShown}
        onClose={() => setPropChatDisclaimerShown(true)}
        closeOnEscape={false}
        closeOnDocumentClick={false}
        contentStyle={{ maxWidth: 500 }}
      >
        <div className="ds-body-font p-4">
          <h1 className="text-xl pb-2 font-semibold">{t('prop-chat.disclaimer-header')}</h1>
          <p>{t('prop-chat.disclaimer-1')}</p>
          <br />
          <p>{t('prop-chat.disclaimer-2')}</p>
          <div className="flex flex-row justify-end pt-4">
            <Button variant="solid" size="md" onClick={() => setPropChatDisclaimerShown(true)}>
              {t('prop-chat.disclaimer-confirm')}
            </Button>
          </div>
        </div>
      </Popup>
      <PropChat
        variant={variant}
        messages={messages}
        onMessage={onMessage}
        loading={loadingStatus}
        loadingMessage={loadingAnswer}
        disabled={disabled}
        isResumedChat={isResumedChat}
      />
    </>
  );
};
